import axiosInstance from "@/api/config";

import { EventSourceMessage } from "@microsoft/fetch-event-source";

import useEventSource from "../useEventSource";

export type UseExecutiveSummaryProps = {
  analysisId?: string;
  onDelta: (chunk: { content: string }, event: EventSourceMessage) => void;
  onFinal: (full: { content: string }, event: EventSourceMessage) => void;
  onDone?: (done: ExecutiveSummaryDone, event: EventSourceMessage) => void;
};

export type ExecutiveSummaryFeedback = {
  comment?: string | null;
  rating: "positive" | "negative";
  reason?: string | null;
};

export type ExecutiveSummaryDone = {
  usage?: {
    input_tokens?: number;
    output_tokens?: number;
    total_tokens?: number;
  };
  feedback?: ExecutiveSummaryFeedback | null;
};

export type ExecutiveSummaryHandlers = {
  "message:delta": { content: string };
  "message:final": { content: string };
  "message:done": ExecutiveSummaryDone;
};

export const useExecutiveSummary = ({
  analysisId,
  onDelta,
  onFinal,
  onDone
}: UseExecutiveSummaryProps) => {
  useEventSource<ExecutiveSummaryHandlers>({
    url: `${axiosInstance.defaults.baseURL}/v1/analysis/${analysisId}/executive-summary`,
    eventKey: "executive-summary",
    parse: JSON.parse,
    eventHandlers: {
      "message:delta": (data, event) => {
        onDelta(data, event);
      },
      "message:final": (data, event) => {
        onFinal(data, event);
      },
      "message:done": (data, event) => {
        onDone?.(data, event);
      }
    },
    enabled: !!analysisId
  });
};
